export default __webpack_public_path__ + "static/media/Snd4.ddd90892.mp3";